import React, { useState } from 'react';

// Hooks
import { useDispatch } from 'react-redux';

// Actions
import { updateWebhookStatus } from '~/redux/actions/webhooks-actions';
import { success, failure } from '~/redux/actions/snackbar-actions';

// Utils
import { MESSAGES } from '~/utils/message';

// Components
import ConfirmModal from '~/components/General/ConfirmModal';

// Icons
import WebhookIcon from '@mui/icons-material/WebhookOutlined';

const ActionModal = (props) => {
  const { openModal, handleCloseModal, selectedWebhook } = props;
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const onSubmit = async () => {
    try {
      setLoading(true);
      let payload = {
        id: selectedWebhook?.id,
        status: selectedWebhook?.status === 'Disabled' ? 'Enabled' : 'Disabled',
      };
      const response = await dispatch(updateWebhookStatus(payload));
      dispatch(success(response.data.message));
      handleCloseModal();
    } catch (error) {
      dispatch(failure(error.response.data.message));
    } finally {
      setLoading(false);
    }
  };

  const isEnabling = selectedWebhook?.status === 'Disabled';

  return (
    <ConfirmModal
      openConfirmModal={{
        open: openModal,
        header: isEnabling
          ? MESSAGES.SETTINGS.WEBHOOKS.STATUS.ENABLE_TITLE
          : MESSAGES.SETTINGS.WEBHOOKS.STATUS.DISABLE_TITLE,
        message: isEnabling
          ? MESSAGES.SETTINGS.WEBHOOKS.STATUS.ENABLE_HEADING
          : MESSAGES.SETTINGS.WEBHOOKS.STATUS.DISABLE_HEADING,
        description: isEnabling
          ? MESSAGES.SETTINGS.WEBHOOKS.STATUS.ENABLE_DESCRIPTION
          : MESSAGES.SETTINGS.WEBHOOKS.STATUS.DISABLE_DESCRIPTION,
        component: <WebhookIcon />,
        containedIcon: true,
        handleOk: onSubmit,
        handleClose: handleCloseModal,
        loading,
        successButtonName: MESSAGES.SETTINGS.WEBHOOKS.STATUS.SUBMIT_BUTTON,
        cancelButtonName: MESSAGES.SETTINGS.WEBHOOKS.STATUS.CANCEL_BUTTON,
      }}
    />
  );
};

export default ActionModal;
